<button class="ws-flex-none ace-btn has-icon btn-primary my-0"
        [disabled]="!canEnterEditMode || !canCreateTaxYear"
        title="Create a tax year for this form revision and copy this tax year to it."
        type="button"
        (click)="createTaxYear()">
    <i class="fa fa-plus"></i>
</button>
